<h1 mat-dialog-title>Votre message a bien été envoyé</h1>
<div mat-dialog-content>Nous allons reprendre contact avec vous rapidement.</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Fermer</button>
</div>
